import { z } from 'zod'

import { api } from '@/modules/shared/lib/axios'
import type { ResponseAPI } from '@/modules/shared/types/response-api.type'
import type {
	ComparativePeriod,
	ComparativeSeller,
} from '../types/comparative-report.type'

export type PayloadComparativeReport = ComparativePeriod

const sellersSchema = z.array(
	z.object({
		fkVendedor: z.number().finite(),
		nomeVendedor: z.string(),
		quantidadeVendas: z.number().finite(),
		valorVenda: z.number().finite(),
		valorCota: z.number().finite(),
		valorFalta: z.number().finite(),
		porc: z.number().finite(),
	}),
)

export async function getComparativeReportService(
	{ ano, mes }: PayloadComparativeReport,
	signal?: AbortSignal,
): Promise<ComparativeSeller[]> {
	const { data } = await api.get<ResponseAPI>(
		`/comparativometa/${ano}/${mes}`,
		{ signal },
	)
	if (data.status === 202) {
		throw new Error(data.message || 'Dados não encontrados, selecione outro período');
	}
	if (data.status !== 200) {
		throw new Error(data.message || 'Não foi possível carregar o comparativo.')
	}
	const body = typeof data.body === 'string' ? JSON.parse(data.body) : data.body
	return sellersSchema.parse(body) as ComparativeSeller[]
}
